var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _path15, _path16, _path17;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCreditCardAmericanExpressBackCvv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.372 10.707h12.743v-.637H8.372v.637zm0 8.284H4.549v-1.274h3.823v-5.098h12.361l8.573-6.123A1.985 1.985 0 0028 6H4a2 2 0 00-2 2v16c0 .603.272 1.137.694 1.504l5.678-4.055v-2.458z",
    fill: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.372 18.991v2.458l3.44-2.458h-3.44zM16.43 15.693l.344-.246v-1.01l-.344 1.256zM12.924 14.488l-.374.946h.755l-.38-.946z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.635 13.893h.591l1.107 2.55h-.607l-.242-.58H12.38l-.228.58h-.593l1.077-2.55zm-4.263 3.823h5.225l2.04-1.457-.497-1.824v2.007h-.519v-2.549h.836l.502 1.74.496-1.74h.838v1.184l3.441-2.458H8.372v5.097z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.924 14.488l.38.946h-.754l.374-.946zm-.545 1.375h1.105l.242.58h.607l-1.107-2.55h-.591l-1.077 2.55h.593l.228-.58zM16.773 14.436v1.012l.52-.371v-1.183h-.838l-.496 1.738-.502-1.738h-.836v2.548h.518v-2.006l.497 1.823.793-.566.344-1.257zM8.372 10.707h12.743v-.637H8.372v.637z",
    fill: "#424143"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.027 15.805h3.186v-.637h-3.186v.637zm4.098-.318a2.508 2.508 0 00-2.505-2.505 2.508 2.508 0 00-2.505 2.505 2.5 2.5 0 001.39 2.23h2.231a2.498 2.498 0 001.39-2.23z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.305 6.496l-8.572 6.123h.382v.072c.826-1.033 2.082-1.709 3.504-1.709a4.51 4.51 0 014.505 4.505 4.509 4.509 0 01-4.505 4.504 4.458 4.458 0 01-2.795-1h-.709v3.823H8.371V21.45l-5.677 4.055A1.98 1.98 0 004 26h24a2 2 0 002-2V8c0-.603-.272-1.137-.694-1.504z",
    fill: "#D7D7D7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.372 21.448v1.366h12.743v-3.823h-9.303l-3.44 2.457zM17.293 16.442h-.52v-.995l-.343.246-.205.75h-.537l-.051-.184-2.04 1.457h7.133a4.452 4.452 0 01-.615-2.23 4.46 4.46 0 011-2.795v-.072h-.382l-3.44 2.458v1.365z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.225 16.442l.205-.749-.793.566.05.183h.538zM16.773 16.442h.52v-1.365l-.52.37v.995z",
    fill: "#686769"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.549 18.991h3.823v-1.274H4.549v1.274zM13.597 17.717H8.372v1.274h3.441l1.784-1.274zM21.115 18.282v.71h.71a4.485 4.485 0 01-.71-.71zM25.736 17.717h-2.232c.337.17.712.274 1.116.274a2.47 2.47 0 001.116-.274z",
    fill: "#424143"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.73 17.717h-7.133l-1.784 1.274h9.303v-.71a4.47 4.47 0 01-.386-.564zM23.027 15.805h3.186v-.637h-3.186v.637z",
    fill: "#424143"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.736 17.717a2.47 2.47 0 01-1.116.274c-.404 0-.779-.104-1.116-.274a2.498 2.498 0 01-1.389-2.23 2.508 2.508 0 012.505-2.505 2.508 2.508 0 012.505 2.505 2.5 2.5 0 01-1.389 2.23zm-1.116-6.735c-1.423 0-2.679.676-3.505 1.71-.616.77-1 1.734-1 2.795 0 .815.234 1.57.614 2.23a4.485 4.485 0 001.095 1.274c.77.617 1.734 1 2.796 1a4.51 4.51 0 004.505-4.504 4.51 4.51 0 00-4.505-4.505z",
    fill: "#E9564B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8a2 2 0 012-2h24a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V8z",
    fill: "#D1D1D1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 12h13v11H8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.275 16.049h-.607l-.242-.58H12.32l-.228.58H11.5l1.077-2.549h.591l1.107 2.549zM15.4 13.5l.502 1.737.497-1.737h.837v2.548h-.52v-2.006l-.548 2.006h-.537l-.052-.184-.496-1.822v2.006h-.519V13.5h.836zm-2.907 1.54h.755l-.38-.946-.375.946z",
    fill: "#424143"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 15.5,
    r: 2.5,
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 19h22v-1.5H5V19zM23 15.8h3v-.6h-3v.6z",
    fill: "#424143"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.61 17.721c-.338.17-.712.274-1.114.274-.403 0-.778-.104-1.114-.274a2.493 2.493 0 01-1.386-2.225c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5c0 .976-.57 1.814-1.386 2.225zM24.496 11c-1.42 0-2.674.675-3.498 1.707A4.449 4.449 0 0020 15.495c0 .813.233 1.567.613 2.225a4.479 4.479 0 001.093 1.271c.768.616 1.73.999 2.79.999a4.5 4.5 0 004.496-4.495A4.501 4.501 0 0024.496 11z",
    fill: "#E9564B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#424143",
    d: "M8 10h13v.6H8z"
  })));
}

export default SvgIconCreditCardAmericanExpressBackCvv;